export const COOKIES_INTRO =
  "Welcome to Comfort-Trip.com. This Cookies Policy explains what cookies are, how we use them, and how you can manage your cookie preferences when using our website.";

export const COOKIE_TYPES = [
  {
    title: "Essential Cookies",
    description:
      "Necessary for the website to function properly. They help with navigation, secure access, and form submissions.",
  },
  {
    title: "Performance & Analytics",
    description:
      "Help us understand how visitors interact with our website by collecting information anonymously.",
  },
  {
    title: "Functional Cookies",
    description:
      "Remember your preferences, such as language or region, for a more personalized experience.",
  },
  {
    title: "Advertising & Marketing",
    description:
      "Deliver relevant advertisements and help us understand the effectiveness of marketing campaigns.",
  },
];

export const COOKIES_SECTIONS = [
  {
    id: "what-are-cookies",
    title: "What Are Cookies?",
    paragraphs: [
      "Cookies are small text files stored on your device by the websites you visit. They are used to make websites work more efficiently, to provide analytics, and to remember your preferences. Cookies are essential for enhancing your browsing experience and enabling certain website functionalities.",
    ],
  },
  {
    id: "types-of-cookies",
    title: "Types of Cookies We Use",
    paragraphs: ["We use several types of cookies on Comfort-Trip.com:"],
    showCookieTypes: true,
  },
  {
    id: "how-we-use",
    title: "How We Use Cookies",
    paragraphs: ["Comfort-Trip.com uses cookies to:"],
    listItems: [
      "Facilitate website functionality and provide a seamless user experience.",
      "Analyze site usage and performance to improve our content and services.",
      "Remember user preferences, such as login information, to enhance your visit.",
      "Offer personalized recommendations and targeted advertisements.",
    ],
  },
  {
    id: "third-party",
    title: "Third-Party Cookies",
    paragraphs: [
      "We may use third-party service providers, such as Google Analytics, to help us understand how users interact with our site. These providers may set their own cookies on our website, which are governed by their respective privacy policies.",
    ],
  },
  {
    id: "managing-cookies",
    title: "Managing Cookies",
    paragraphs: [
      "You can control your cookie preferences through your browser settings. Most browsers allow you to block or delete cookies. However, please note that disabling cookies may impact your user experience and limit certain features on Comfort-Trip.com.",
    ],
  },
  {
    id: "updates",
    title: "Updates to Our Cookies Policy",
    paragraphs: [
      "We may occasionally update our Cookies Policy to reflect changes in our practices. Any updates will be posted on this page, so please review it periodically.",
    ],
  },
  {
    id: "contact",
    title: "Contact Us",
    paragraphs: [
      "If you have questions about our Cookies Policy, please contact us at support@comfort-trip.com.",
    ],
  },
];
